import { render, staticRenderFns } from "./progressBar.vue?vue&type=template&id=5b5a4981&scoped=true&"
import script from "./progressBar.vue?vue&type=script&lang=js&"
export * from "./progressBar.vue?vue&type=script&lang=js&"
import style0 from "./progressBar.vue?vue&type=style&index=0&id=5b5a4981&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5a4981",
  null
  
)

component.options.__file = "progressBar.vue"
export default component.exports